import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid gap-4 py-4" }
const _hoisted_2 = { class: "grid grid-cols-4 items-center gap-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_4 = { class: "col-span-3" }
const _hoisted_5 = { class: "grid grid-cols-4 items-center gap-4" }

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { ref } from 'vue';
import { set } from '@vueuse/core';
import { parsePresentationNameToWorkflowCode } from '@/models/workflow';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkflowCreationDialog',
  props: {
    "isModalCreationOpen": {
  type: Boolean,
  default: false
},
    "isModalCreationOpenModifiers": {},
    "isWorkflowDataValid": {
  type: Boolean,
  default: true
},
    "isWorkflowDataValidModifiers": {},
    "validationErrorMessage": {
  type: String,
  default: undefined
},
    "validationErrorMessageModifiers": {},
  },
  emits: /*#__PURE__*/_mergeModels(['try-to-save-workflow'], ["update:isModalCreationOpen", "update:isWorkflowDataValid", "update:validationErrorMessage"]),
  setup(__props, { emit: __emit }) {

const isModalCreationOpen = _useModel(__props, 'isModalCreationOpen');

const isWorkflowDataValid = _useModel(__props, 'isWorkflowDataValid');

const validationErrorMessage = _useModel(__props, 'validationErrorMessage');

const emit = __emit;
const name = ref<string | undefined>(undefined);
const notes = ref<string | undefined>(undefined);

const tryToSaveWorkflow = () => {
  if (name.value === undefined) {
    isWorkflowDataValid.value = false;
    validationErrorMessage.value = "O nome não pode ser vazio!";
    return;
  }

  const workflowCode = parsePresentationNameToWorkflowCode(name.value);
  const creationRequest = {
    "workflowCode": workflowCode,
    "presentationName": name.value.trim(),
    "notes": notes.value?.trim()
  };

  emit('try-to-save-workflow', creationRequest, clearInputs);
};

const clearInputs = () => {
  set(name, undefined);
  set(notes, undefined);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: isModalCreationOpen.value,
    "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((isModalCreationOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-[425px] z-40" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Criação de Fluxo")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Label), {
                for: "presentationName",
                class: "text-right"
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createTextVNode(" Nome: ")
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  class: _normalizeClass(["text-red-500", { 'invisible': isWorkflowDataValid.value }])
                }, _toDisplayString(validationErrorMessage.value), 3),
                _createVNode(_unref(Input), {
                  id: "presentationName",
                  class: _normalizeClass({
                'border-gray-300': isModalCreationOpen.value,
                'border-red-500': !isWorkflowDataValid.value
              }),
                  modelValue: name.value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                    _cache[1] || (_cache[1] = () => isWorkflowDataValid.value = true)
                  ]
                }, null, 8, ["class", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Label), {
                for: "notes",
                class: "text-right"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Descrição: ")
                ]),
                _: 1
              }),
              _createVNode(_unref(Input), {
                id: "notes",
                class: "col-span-3",
                modelValue: notes.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((notes).value = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode(_unref(DialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                onClick: tryToSaveWorkflow,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Salvar Fluxo ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["open"]))
}
}

})